<template>
  <div style="width: 100%">
    <div class="container mt-1 player-list-container">
      <div
        v-for="player in players"
        :key="player.uid"
        class="player-info-row align-center white--text pb-2 mt-2">
        <div class="d-flex" style="width: 30%">
          <div style="max-width: 70px">
            <v-avatar class="player-avatar-avatar" :size="70">
              <img :src="player.imgUrl" @error="defaultImageProfile" />
            </v-avatar>
          </div>
          <div class="d-flex flex-column ml-3 align-self-center">
            <div>
              <h3 class="player-name">{{ player.firstName }}</h3>
              <img
                class="current-streak-icon"
                :src="icons.currentStreak.default" />
              <span class="current-streak">
                {{ player.currentStreak || 0 }}
              </span>
            </div>
            <div>
              <span>{{ player.email }}</span>
            </div>
          </div>
        </div>
        <div class="align-center d-flex flex-column" style="width: 40%">
          <div>
            <v-chip
              pill
              dark
              large
              :disabled="!player.bpEmail"
              color="accent"
              rounded>
              <v-icon class="mr-1" v-if="player.bpEmail">
                mdi-checkbox-marked-circle
              </v-icon>
              <v-icon class="mr-1" v-else>
                mdi-checkbox-blank-circle-outline
              </v-icon>
              Beyond Pulse
            </v-chip>
          </div>
          <!-- <div>
            <v-btn
              dark
              color="green"
              :disabled="!player.veoProfileLink"
              rounded
              @click="getVeoShowcaseLink(player)"
            >Veo showcase</v-btn>
          </div>-->
        </div>
        <div
          style="
            width: 30%;
            display: flex;
            flex-grow: 1;
            justify-content: flex-end;
          ">
          <div>
            <v-btn
              color="primary"
              style="min-width: 40px"
              @click="goToPlayerProfile(player)">
              <v-icon style="color: white">fas fa-angle-right</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants.js"

export default {
  name: "PlayerList",
  props: ["players"],
  data() {
    return {
      icons: constants.icons,
    }
  },
  mounted() {},

  computed: {},

  methods: {
    defaultImageProfile(event) {
      event.target.src = require("@/assets/icons/defaultProfileImg.png").default
    },
    goToPlayerProfile(player) {
      this.$router.push({
        name: "ProfileInfo",
        params: { id: player.id ?? player.uid },
      })
    },
  },
}
</script>

<style scoped lang="sass">
@import '@/assets/sass/_variables.sass'
.player-info-row
  display: flex
  justify-content: space-between
  border-bottom: 1px solid white

.player-list-container
  overflow: auto
  max-height: calc(100vh - 50px)

.player-name
  display: inline-block

.current-streak-icon
  width: 2.5rem
  display: inline-block
  transform: translateY(18%)

.current-streak
  display: inline-block
  position: relative
  transform: translateX(-310%)
</style>
